<!--
 * @FileDescription: 设备管理页面
 -->
<template>
  <div class="bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">{{ $t('deviceManagement') }} > {{ $t('EquipmentList') }}</div>
    <div class="common-table-cnt">
      <div class="search search-container app-upgrade">
        <!-- 查询表单 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline" style="overflow: auto;">
          <el-form-item :label="$t('mechanism')">
            <el-select
              ref="paramOuSelect"
              v-model="paramOuName"
              style="width:auto"
              :placeholder="$t('peaseSelect')"
              @change="changeParamOu"
              clearable
              @visible-change="visibleChange"
            >
              <el-option :value="paramOuName" style="height:auto;padding:0px">
                <el-tree
                  ref="paramOuTree"
                  node-key="id"
                  default-expand-all
                  highlight-current
                  :expand-on-click-node="false"
                  :data="userData.ouList"
                  :props="defaultProps"
                  @node-click="selectParamOu"
                >
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          <span v-show="activeName === 'IntelligentDevice'">
            <el-form-item :label="$t('deviceType')">
              <el-select
                v-model="formInline.specType"
                clearable
                :placeholder="$t('deviceType')"
              >
                <template v-for="item of helmetType">
                  <el-option
                    v-if="checkDeviceType(item.value)"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </template>
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('bindingStatus')">
              <el-select
                v-model="formInline.binded"
                clearable
                :placeholder="$t('bindingStatus')"
              >
                <el-option :label="$t('bound')" value="1"></el-option>
                <el-option :label="$t('Unbound')" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('serialNumberP2')">
              <el-input v-model="formInline.serialNumber" clearable :placeholder="$t('serialNumberP2')"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getList" class="serachBtn">{{ $t('query') }}</el-button>
              <el-button type="primary" @click="exportList" :loading="listLoading" class="serachBtn">{{
                $t('exportButton')
              }}</el-button>

              <!-- 公有云环境导出国标参数模板 超级管理员用户权限 -->
              <div v-if="isCloud && loginIsAdmin === '1' && !isOnlySupportIH5">
                <el-button type="primary" @click="exportExcel" :loading="exportLoading" class="add-btn">
                  {{ $t('exportDeviceGbConfig') }}
                </el-button>
              </div>
              <!-- 公有云环境导入国标参数模板 超级管理员用户权限 -->
              <!-- <div v-if="isCloud && loginIsAdmin === '1' && !isOnlySupportIH5">
            </div> -->
              <el-upload
                v-if="isCloud && loginIsAdmin === '1' && !isOnlySupportIH5"
                action="string"
                :http-request="importExcel"
                :multiple="false"
                :show-file-list="false"
              >
                <el-button type="primary" class="add-btn" :loading="importLoading">
                  {{ $t('importDeviceGbConfig') }}
                </el-button>
              </el-upload>
              <!-- 私有化云环境新增设备 -->
              <div v-if="!isCloud">
                <el-button
                  type="primary"
                  v-has="'sys:new:setting:device:add'"
                  @click="helmetEditHandleClick(null, true)"
                  class="serachBtn"
                >
                  {{ $t('newEquipment') }}
                </el-button>
              </div>
              <!-- 私有化云环境导出设备模板 -->
              <div v-if="!isCloud">
                <el-button
                  type="primary"
                  @click="exportExcel"
                  v-has="'sys:new:setting:device:add'"
                  v-if="loginIsAdmin == '1'"
                  :loading="exportLoading"
                  class="add-btn"
                >
                  {{ !isCloud ? $t('downloadTemplate') : $t('exportDeviceGbConfig') }}
                </el-button>
              </div>
              <!-- 私有化云环境导入设备 -->
              <el-upload
                v-has="'sys:new:setting:device:add'"
                v-if="loginIsAdmin == '1' && !isCloud"
                action="string"
                :http-request="importExcel"
                :multiple="false"
                :show-file-list="false"
              >
                <el-button type="primary" class="add-btn" :loading="importLoading">
                  {{ $t('batchImportAdd') }}{{ $t('newlyAded') }}
                </el-button>
              </el-upload>
            </el-form-item>
          </span>
          <span v-show="activeName === 'controlCabinet'">
            <el-form-item :label="$t('serialNumberP')">
              <el-input v-model="formInline.serialNumber" clearable :placeholder="$t('serialNumberP')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('nameC')">
              <el-input v-model="formInline.cabinetName" clearable :placeholder="$t('nameC')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('controlCabinetNumber')" class="datetime">
              <el-input clearable class="startWorkDuration" v-model="formInline.minCellNum"></el-input>
            </el-form-item>
            <el-form-item :label="$t('TO')">
              <el-input clearable class="endWorkDuration" v-model="formInline.maxCellNum"></el-input>
            </el-form-item>
            <el-form-item :label="$t('state')">
              <el-select
                v-model="formInline.cabinetStatus"
                clearable
                :placeholder="$t('state')"
              >
                <el-option :label="$t('enable')" value="1"></el-option>
                <el-option :label="$t('disable')" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getList" class="serachBtn">{{ $t('query') }}</el-button>
              <el-button
                type="primary"
                v-if="loginIsAdmin == '1'"
                @click="cabinetHandleClick(null, true)"
                class="serachBtn"
              >
                {{ $t('newEquipment') }}
              </el-button>
            </el-form-item>
          </span>
        </el-form>
      </div>
      <div class="common-blue-tabs view-info">
        <el-tabs v-model="activeName" type="card" @tab-click="handleTab">
          <el-tab-pane :label="$t('IntelligentDevice')" name="IntelligentDevice"></el-tab-pane>
          <el-tab-pane :label="$t('controlEquipment')" name="controlCabinet"> </el-tab-pane>
        </el-tabs>
      </div>
      <div class="table-box" v-show="activeName === 'IntelligentDevice'">
        <!-- table开始  -->
        <el-table :data="tableData" style="width: 100%;" @sort-change="sortChange">
          <el-table-column
            type="index"
            :index="indexMethod"
            :label="$t('SerialNo')"
            align="center"
            width="80"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="serialNumber"
            :label="$t('serialNumberP2')"
            width="220"
            sortable="serialNumber"
            :show-overflow-tooltip="true"
            :sort-orders="['ascending', 'descending']"
          >
          </el-table-column>
          <el-table-column
            prop="specModel"
            :label="$t('specificationModel')"
            width="140"
            sortable="specModel"
            :show-overflow-tooltip="true"
            :sort-orders="['ascending', 'descending']"
          >
          </el-table-column>
          <el-table-column
            prop="specType"
            :label="$t('deviceType')"
            width="150"
            sortable="specType"
            align="center"
            :sort-orders="['ascending', 'descending']"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.specType | helmetType }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fullOuName"
            :label="$t('mechanism')"
            sortable="fullOuName"
            :show-overflow-tooltip="true"
            :sort-orders="['ascending', 'descending']"
          >
          </el-table-column>
          <el-table-column
            prop="userName"
            :label="$t('binder')"
            sortable="userName"
            :show-overflow-tooltip="true"
            :sort-orders="['ascending', 'descending']"
          >
          </el-table-column>
          <el-table-column
            :label="$t('state')"
            width="80"
            show-overflow-tooltip
            sortable="onlineStatus"
            align="center"
            :sort-orders="['ascending', 'descending']"
          >
            <template slot-scope="scope">
              <span :class="scope.row.onlineStatus === 1 ? 'online' : 'offline'">{{
                $t(scope.row.onlineStatus === 1 ? 'onLine' : 'offLine')
              }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('operationh')" align="center" :width="word !== 'en' ? 240 : 180">
            <template slot-scope="scope">
              <span class="editClick" v-has="'sys:new:setting:device:edit'" @click="helmetEditHandleClick(scope.row)">
                {{ $t('edit') }}
              </span>
              <span class="editClick" v-if="loginIsAdmin == '1' && !isCloud" @click="deleteHelmet(scope.row.id)">
                {{ $t('delete') }}
              </span>
              <span class="editClick" @click="bindRecordClick(scope.row)">{{ $t('bindingHistory') }}</span>
              <span class="editClick" v-if="powers(scope.row)" @click="interClick(scope.row)">
                {{ $t('deviceConfig') }}
              </span>
              <span class="editClick" v-if="scope.row.specType === 0" @click="getHealthChart(scope.row)">
                {{ $t('viewData') }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalData"
        >
        </el-pagination>
      </div>
      <ControlCabinet ref="cabinet" :ouList="userData.ouList" v-show="activeName === 'controlCabinet'"></ControlCabinet>
    </div>
    <!--新增、编辑设备窗口-->
    <el-dialog
      class="helmetDialogMax"
      :title="editDevice ? $t('editDevice') : $t('newEquipment')"
      :visible.sync="newUserDialogTableVisible"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <div class="common-blue-contain">
        <el-form :model="newUserForm">
          <el-form-item :label="$t('serialNumberP2')" :label-width="formLabelWidth" :required="true">
            <el-input
              v-model="newUserForm.serialNumber"
              autocomplete="off"
              :placeholder="$t('pleaseEnter') + $t('serialNumberP2')"
              :disabled="isCloud ? true : editDevice && !isCloud ? true : false"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('specificationModel')" :label-width="formLabelWidth" :required="true">
            <el-input v-if="isCloud" v-model="newUserForm.specModel" autocomplete="off" :disabled="true"></el-input>
            <el-select
              v-if="!isCloud"
              v-model="newUserForm.specModel"
              :placeholder="$t('selectSpecification')"
              popper-append-to-body
            >
              <el-option v-for="item of specModelList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('EquipmentStatus')" :label-width="formLabelWidth">
            <el-select v-model="newUserForm.status" :label="$t('EquipmentStatus')" popper-append-to-body>
              <el-option :label="$t('enable')" :value="1"></el-option>
              <el-option :label="$t('disable')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('phoneNumber')" :label-width="formLabelWidth">
            <el-input
              v-model="newUserForm.phoneNumber"
              autocomplete="off"
              maxlength="11"
              class="formInput"
              :placeholder="$t('enterMobileNum')"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('mechanism')" :label-width="formLabelWidth">
            <el-select
              ref="ouSelect"
              v-model="ouName"
              style="width:auto"
              :placeholder="$t('peaseSelect')"
              popper-append-to-body
              @change="changeOu"
              clearable
              @visible-change="visibleChange"
            >
              <el-option :value="ouName" style="height:auto;padding:0px">
                <el-tree
                  ref="ouTree"
                  node-key="id"
                  :default-expanded-keys="defaultExpandIds"
                  @node-expand="handleNodeExpand"
                  @node-collapse="handleNodeCollapse"
                  highlight-current
                  :expand-on-click-node="false"
                  :data="userData.ouList"
                  :props="defaultProps"
                  @node-click="selectOu"
                >
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('binder')" :label-width="formLabelWidth">
            <el-select
              v-model="userData.id"
              filterable
              clearable
              :placeholder="$t('selectBindingPersonnel')"
              @change="selectUser"
              popper-append-to-body
            >
              <el-option :value="item.id" v-for="item of userData.selectList" :key="item.id" :label="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="alert-tip">
          {{ $t('changeBinding') }}
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="!editDevice" type="primary" @click="save()">{{ $t('determine') }}</el-button>
        <el-button v-if="editDevice" type="primary" @click="submitFormUser()">{{ $t('determine') }}</el-button>
        <el-button @click="newUserDialogTableVisible = false">{{ $t('cancel') }}</el-button>
      </div>
    </el-dialog>
    <!--设备绑定历史窗口-->
    <el-dialog
      class="helmetBindRecord common-blue-contain"
      width="60%"
      :title="$t('bindingRecord')"
      :visible.sync="helmetBindRecordDialogVisible"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <el-table :data="recordTableData" height="390" style="width: 100%;" @sort-change="sortChildChange">
        <el-table-column type="index" :index="indexMethod" :label="$t('SerialNo')" width="90" align="center">
        </el-table-column>
        <el-table-column prop="deviceSN" :label="$t('serialNumberP2')"> </el-table-column>
        <el-table-column
          prop="type"
          :label="$t('bindingType')"
          align="center"
          sortable="type"
          width="130"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot-scope="scope">
            {{ scope.row.type === 1 ? $t('binding') : '' }}
            {{ scope.row.type === 2 ? $t('unbinding') : '' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="builderName"
          :label="$t('namePersonnel')"
          sortable="builderName"
          :sort-orders="['ascending', 'descending']"
        >
        </el-table-column>
        <el-table-column
          prop="createdTime"
          width="170"
          :label="$t('dateh')"
          align="center"
          sortable="createdTime"
          :sort-orders="['ascending', 'descending']"
        >
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleRecordSizeChange"
        @current-change="handleRecordCurrentChange"
        :current-page="recordCurrentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="recordPageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="recordTotalData"
      >
      </el-pagination>
    </el-dialog>
    <!-- 如果有权限，即可查看历史数据 -->
    <el-dialog
      :title="$t('viewData') + serialNum"
      :visible.sync="infoVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="60%"
      class="view-info common-blue-contain"
    >
      <Historical :rowData="rowData"></Historical>
    </el-dialog>
    <!-- 国际参数窗口 -->
    <InternatParameters ref="internatParams"></InternatParameters>
  </div>
</template>

<script>
import { downloadBlobExcel } from '@/util/common'
import Historical from '@/components/historical'
import { HELMET_TYPE } from '@/common/enum'
import { errorCollection } from '@/api/dmp/dmpCollection'
import InternatParameters from '@/views/new-set/device-manage/InternatParameters'
import ControlCabinet from '@/views/new-set/device-manage/controlCabinet'
import {
  gethelmet,
  editHelmet,
  getUser,
  getHelmetBindRecord,
  exportHelmet,
  deleteHelmet,
  addHelmet,
  updateHelmet,
  bindHelmet,
  exportExcel,
  importExcel,
} from '@/api/helmetManage'
import { getOus } from '@/api/UserList'
import { deepClone } from '@/util/Utils'
import { mapGetters } from 'vuex'

export default {
  components: { Historical, InternatParameters, ControlCabinet },
  data() {
    return {
      loginIsAdmin: sessionStorage.getItem('isAdmin'),
      // 表单查询参数
      formInline: {
        serialNumber: '',
        specModel: '',
        status: '',
        binded: '',
        specType: '',
      },
      // table数据
      tableData: [],
      editDevice: true,
      // 显示编辑设备弹窗口
      newUserDialogTableVisible: false,
      // 当前设备id
      currentDeviceId: null,
      // 设备绑定历史窗口显示
      helmetBindRecordDialogVisible: false,
      // 设备绑定历史 table记录
      recordTableData: [],
      recordCurrentPage: 1,
      recordPageSize: 10,
      recordTotalData: 0,
      // 编辑设备表单参数
      paramOuName: '',
      ouName: '',
      newUserForm: {
        name: '',
        roleId: '',
        ouId: '',
      },

      formLabelWidth: '130px',
      userDialog: true,
      newUserDialogTableVisibleBefore: null,

      // 绑定人员 数据
      userData: {
        ouList: [],
        selectList: [],
        id: null,
      },
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      currentPage: 1,
      pageSize: 10,
      totalData: 0,
      // 查看数据弹窗
      infoVisible: false,
      rowData: [],
      // 传输设备序列号
      serialNum: '',
      // 设备类型选择查询
      helmetType: HELMET_TYPE,
      specModelList: this.getSpecModel(),
      exportLoading: false,
      importLoading: false,
      // 这里存放要默认展开的节点 id
      defaultExpandIds: [],
      firstId: '',
      // 历史记录排序参数 =====
      currentSortitem: null,
      sortColName: '',
      useAsc: 0,
      // ===========
      listLoading: false,
      activeName: 'IntelligentDevice',
      word: localStorage.getItem('lang'),
    }
  },
  methods: {
    // 新增管控柜
    cabinetHandleClick() {
      this.$refs.cabinet.addDevice()
    },
    // 切换tab
    handleTab() {
      if (this.activeName === 'controlCabinet') {
        this.$refs.cabinet.getList(this.formInline)
      } else {
        this.getList()
      }
    },
    // 设备绑定历史记录排序
    sortChildChange({ column, prop, order }) {
      this.sortColName = column.sortable
      this.useAsc = order === 'descending' ? 0 : 1
      this.recordCurrentPage = 1
      this.bindRecordClick()
    },
    // 点击表头排序
    sortChange({ column, prop, order }) {
      this.formInline.sortColName = !order ? null : column.sortable
      this.formInline.useAsc = order === 'descending' ? 0 : 1
      this.getList()
    },
    // 机构查询 滚动条置顶
    visibleChange(val) {
      this.$nextTick(() => {
        let ele = document.querySelector('.el-select-dropdown__wrap')
        ele.scrollTop = ele.scrollHeight
      })
    },
    // 点击 '查看数据',弹窗显示，数据传到子组件
    getHealthChart(row) {
      this.serialNum = row !== '' ? row.serialNumber : this.serialNum
      this.rowData = row
      this.infoVisible = true
    },
    // 点击查询列表
    getList() {
      this.currentPage = 1
      if (this.activeName === 'controlCabinet') {
        this.$refs.cabinet.getList(this.formInline)
      } else {
        this.search()
      }
    },
    // 点击导出列表
    exportList() {
      if (this.totalData >= 100000) {
        this.$message({
          type: 'warning',
          message: this.$t('maxFile'), //提示用户数据量过大，无法导出
        })
        return
      }
      this.listLoading = true
      let params = {
        serialNumber: this.formInline.serialNumber,
        specModel: this.formInline.specModel,
        status: this.formInline.status,
        binded: this.formInline.binded,
        ouId: this.formInline.ouId,
        specType: this.formInline.specType,
      }
      exportHelmet(params).then(res => {
        this.listLoading = false
        downloadBlobExcel(res, this.$t('deviceListInformation') + '.xls')
      })
    },
    // 获取列表
    search() {
      let params = {
        serialNumber: this.formInline.serialNumber,
        specModel: this.formInline.specModel,
        status: this.formInline.status,
        binded: this.formInline.binded,
        ouId: this.formInline.ouId,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        specType: this.formInline.specType,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      gethelmet(params).then(res => {
        if (res.state === 0) {
          this.tableData = res.data.list
          this.totalData = res.data.total
        }
      })
    },
    // 获取组织机构
    getOusTree() {
      getOus().then(res => {
        if (res.state === 0) {
          this.userData.ouList = res.data
          if (this.userData.ouList[0] && this.userData.ouList[0].id) {
            this.firstId = this.userData.ouList[0].id
            if (this.defaultExpandIds.indexOf(this.userData.ouList[0].id) === -1) {
              this.defaultExpandIds.push(this.firstId)
            }
          }
        }
      })
    },
    // 树节点展开
    handleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false
      this.defaultExpandIds.some(item => {
        if (item === data.id) {
          // 判断当前节点是否存在， 存在不做处理
          flag = true
          return true
        }
      })
      if (!flag) {
        // 不存在则存到数组里
        this.defaultExpandIds.push(data.id)
      }
    },
    // 树节点关闭
    handleNodeCollapse(data) {
      if (data.id === this.firstOuId) {
        this.defaultExpandIds = []
        return
      }
      // 删除当前关闭的节点
      this.defaultExpandIds.some((item, i) => {
        if (item === data.id) {
          this.defaultExpandIds.splice(i, 1)
        }
      })
      if (data.children) {
        this.removeChildrenIds(data) // 这里主要针对多级树状结构，当关闭父节点时，递归删除父节点下的所有子节点
      }
    },
    // 删除树子节点
    removeChildrenIds(data) {
      const ts = this
      if (data.children) {
        data.children.forEach(function(item) {
          const index = ts.defaultExpandIds.indexOf(item.id)
          if (index > 0) {
            ts.defaultExpandIds.splice(index, 1)
          }
          if (item.id) {
            ts.removeChildrenIds(item)
          }
        })
      }
    },
    // 选中机构，过滤用户
    selectOu(data) {
      this.ouName = data.name
      this.newUserForm.ouId = data.id
      this.getUser({ ouId: data.id })
      this.$refs.ouSelect.blur()
    },
    changeOu(data) {
      if (!data) {
        this.$nextTick(() => {
          this.$refs.ouTree.setCurrentKey(null)
        })
        this.getUser({ ouId: null })
      }
    },
    // 选中过滤条件机构，过滤用户
    selectParamOu(data) {
      this.paramOuName = data.name
      this.formInline.ouId = data.id
      this.$refs.paramOuSelect.blur()
    },
    // 清空过滤条件机构，过滤用户
    changeParamOu(data) {
      if (!data) {
        this.formInline.ouId = null
        this.$nextTick(() => {
          this.$refs.paramOuTree.setCurrentKey(null)
        })
      }
    },
    // 选中用户，回填机构
    selectUser(userId) {
      for (let item of this.userData.selectList) {
        if (item.id === userId) {
          this.ouName = item.ouName
          this.newUserForm.ouId = item.ouId
          this.$nextTick(() => {
            this.$refs.ouTree.setCurrentKey(item.id)
          })
          return
        }
      }
    },
    //保存设备
    save() {
      if (!this.newUserForm.serialNumber) {
        errorCollection('设置》设备管理', '新增/编辑设备', {
          status: 200,
          data: { state: -1, msg: '请输入设备序列号' },
        })
        this.$message({ type: 'error', message: this.$t('pleaseEnter') + this.$t('serialNumberP2') })
        return
      }
      if (this.newUserForm.serialNumber.length < 9) {
        errorCollection('设置》设备管理', '新增/编辑设备', {
          status: 200,
          data: { state: -1, msg: '设备序列号至少九个字符' },
        })
        this.$message({ type: 'error', message: '设备序列号至少九个字符' })
        return
      }
      if (!this.newUserForm.specModel) {
        errorCollection('设置》设备管理', '新增/编辑设备', {
          status: 200,
          data: { state: -1, msg: '请选择规格型号' },
        })
        this.$message({ type: 'error', message: this.$t('selectSpecification') })
        return
      }
      addHelmet(this.newUserForm).then(res => {
        console.log(this.newUserForm)
        if (res.state === 0) {
          if (this.userData.id) {
            let param = {
              deviceId: res.data.id,
              userId: this.userData.id,
            }
            bindHelmet(param).then(bindRes => {
              if (bindRes.state === 0) {
                this.search()
                this.$message({ type: 'success', message: this.$t('AddSuccess') })
                this.newUserDialogTableVisible = false
              }
            })
          } else {
            this.search()
            this.$message({ type: 'success', message: this.$t('AddSuccess') })
            this.newUserDialogTableVisible = false
          }
        }
      })
    },
    // 删除设备
    deleteHelmet(id) {
      this.$confirm(this.$t('deleteDevice'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        deleteHelmet(id).then(res => {
          if (res.state === 0) {
            this.$message({ type: 'success', message: this.$t('deleteSuccess') })
            this.search()
          }
        })
      })
    },
    // 提交编辑信息
    submitFormUser() {
      if (this.isCloud) {
        this.cloudsubmitForm()
      } else {
        this.intreasubmitForm()
      }
    },
    intreasubmitForm() {
      if (!this.newUserForm.serialNumber) {
        errorCollection('设置》设备管理', '编辑设备', {
          status: 200,
          data: { state: -1, msg: '请输入设备序列号' },
        })
        this.$message({ type: 'error', message: this.$t('pleaseEnter') + this.$t('serialNumberP2') })
        return
      }
      if (!this.newUserForm.specModel) {
        errorCollection('设置》设备管理', '编辑设备', {
          status: 200,
          data: { state: -1, msg: '请选择规格型号' },
        })
        this.$message({ type: 'error', message: this.$t('selectSpecification') })
        return
      }
      updateHelmet(this.newUserForm).then(res => {
        if (res.state === 0) {
          let param = {
            deviceId: res.data.id,
            userId: this.userData.id,
          }
          bindHelmet(param).then(bindRes => {
            if (bindRes.state === 0) {
              this.search()
              this.$message({ type: 'success', message: this.$t('EditSucceeded') })
              this.newUserDialogTableVisible = false
            }
          })
        }
      })
    },
    // 公有云提交编辑信息
    cloudsubmitForm() {
      let obj = this.newUserForm
      let param = {
        deviceId: obj.id,
        ouId: obj.ouId,
        userId: this.userData.id,
        phoneNumber: obj.phoneNumber ? obj.phoneNumber : '',
      }
      editHelmet(param).then(res => {
        if (res.state === 0) {
          this.search()
          this.$message({ type: 'success', message: '编辑成功!' })
          this.newUserDialogTableVisible = false
        }
      })
    },
    // 获取编辑时的绑定人员列表
    getUser(row) {
      let param = { binded: '0', ouId: row ? row.ouId : null }
      this.userData.id = null
      getUser(param).then(res => {
        if (res.state === 0) {
          this.userData.selectList = res.data
          if (row && row.userId) {
            this.userData.selectList.unshift({
              id: row.userId,
              name: row.userName,
            })
            this.userData.id = row.userId
          }
        }
      })
    },
    // 点击编辑设备信息
    helmetEditHandleClick(row, create = false) {
      console.log(row, 'row')
      this.editDevice = !create
      this.defaultExpandIds = []
      if (!this.isCloud) {
        if (this.editDevice) {
          this.newUserDialogTableVisibleBefore = deepClone(row)
          this.defaultExpandIds = [this.firstId, this.newUserDialogTableVisibleBefore.ouId]
          this.$nextTick(() => {
            this.ouName = this.newUserDialogTableVisibleBefore.ouName
            this.newUserForm = this.newUserDialogTableVisibleBefore
            this.$refs.ouTree.setCurrentKey(this.newUserDialogTableVisibleBefore.ouId)
          })
        } else {
          this.newUserForm = {
            serialNumber: '',
            specModel: '',
            status: 1,
            phoneNumber: '',
            wellNum: '',
          }
        }
      } else {
        this.newUserDialogTableVisibleBefore = deepClone(row)
        this.$nextTick(() => {
          this.ouName = this.newUserDialogTableVisibleBefore.ouName
          this.newUserForm = this.newUserDialogTableVisibleBefore
          this.$refs.ouTree.setCurrentKey(this.newUserDialogTableVisibleBefore.ouId)
        })
      }
      this.getUser(row)

      this.userDialog = false
      this.newUserDialogTableVisible = true
      console.log(this.defaultExpandIds)
    },
    // 点击绑定历史，获取设备绑定历史记录
    bindRecordClick(row) {
      this.currentSortitem = row ? row : this.currentSortitem
      let params = {
        id: this.currentSortitem.id,
        pageNum: this.recordCurrentPage,
        pageSize: this.recordPageSize,
        sortColName: this.sortColName,
        useAsc: this.useAsc,
      }
      this.currentDeviceId = this.currentSortitem.id
      this.recordTableData = []
      getHelmetBindRecord(params).then(res => {
        if (res.state === 0) {
          this.recordTableData = res.data.list
          this.recordTotalData = res.data.total
          this.helmetBindRecordDialogVisible = true
        }
      })
    },
    // 下载批量导入设备模板
    exportExcel() {
      this.exportLoading = true
      exportExcel().then(res => {
        if (!res['state']) {
          let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, 'importTemplate')
          } else {
            // 非IE下载
            const elink = document.createElement('a')
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            elink.download = this.$t('batchiportequipment')
            document.body.appendChild(elink)
            elink.click()
            setTimeout(() => {
              URL.revokeObjectURL(elink.href) // 释放URL 对象
              document.body.removeChild(elink)
            }, 5000) //解决部分浏览器下载时“无此文件”问题
          }
        } else {
          this.$message({
            type: 'error',
            message: this.$t('failedDownloadTemplate'),
            customClass: 'zZindex',
            duration: 2000,
          })
        }
        this.exportLoading = false
      })
    },
    // 批量导入设备
    importExcel(params) {
      this.importLoading = true
      const _file = params.file
      // 通过 FormData 对象上传文件
      let formData = new FormData()
      formData.append('file', _file)
      importExcel(formData).then(res => {
        if (res['type'] !== 'application/json') {
          this.$confirm(this.$t('Importfailed'), {
            confirmButtonText: this.$t('download'),
            cancelButtonText: this.$t('cancel'),
            type: 'error',
            closeOnClickModal: false,
          })
            .then(() => {
              let errorImportBlob = new Blob([res], {
                type: 'application/vnd.ms-excel',
              }) // res就是接口返回的文件流了
              if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(errorImportBlob, 'errorImportData')
              } else {
                // 非IE下载
                const errorImportDataElink = document.createElement('a')
                errorImportDataElink.style.display = 'none'
                errorImportDataElink.href = URL.createObjectURL(errorImportBlob)
                errorImportDataElink.download = this.$t('importWrongDevice')
                document.body.appendChild(errorImportDataElink)
                errorImportDataElink.click()
                setTimeout(() => {
                  URL.revokeObjectURL(errorImportDataElink.href) // 释放URL 对象
                  document.body.removeChild(errorImportDataElink)
                }, 5000) //解决部分浏览器下载时“无此文件”问题
              }
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('errorDataCanceled'),
              })
            })
        } else {
          this.$message({
            type: 'success',
            message: this.$t('importComplete'),
          })
          this.getList()
        }
        this.importLoading = false
      })
    },
    //判断用户是否是超级管理员用户以及非帽衬设备
    powers(row) {
      let powerNet = false
      let loginIsAdmin = sessionStorage.getItem('isAdmin')
      if (loginIsAdmin === '1' && row.specType !== 0) {
        powerNet = true
      }
      return powerNet
    },

    //国标参数
    interClick(row) {
      this.$refs.internatParams.handleClick(row)
    },

    /**
     * 获取头盔规格型号
     */
    getSpecModel() {
      return localStorage.getItem('DEVICE_SPEC_MODEL').split(',')
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.search()
    },
    handleRecordSizeChange(val) {
      this.recordPageSize = val
      this.bindRecordClick({ id: this.currentDeviceId })
    },
    handleRecordCurrentChange(val) {
      this.recordCurrentPage = val
      this.bindRecordClick({ id: this.currentDeviceId })
    },
    indexMethod(index) {
      return index + 1
    },
    /**
     * 检查头盔类型
     */
    checkDeviceType(specType) {
      return localStorage.getItem('DEVICE_SPEC_TYPE').indexOf(specType + '') === -1 ? false : true
    },
  },
  mounted() {
    this.getOusTree()
    this.search()
  },
  computed: {
    ...mapGetters(['isCloud', 'isOnlySupportIH5']),
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl';
.common-blue-tabs
  >>>.el-tabs__header
    margin 0
>>>.el-table {
  min-height: 460px; /* no */
  overflow: auto;
}

.alert-tip {
  font-style: italic;
  color: #409eff;
}

.el-dialog {
  >>>.el-popper {
    min-width: 315px !important;
  }
}
>>>.el-button+.el-button {
  margin-left: 10px;
}

>>> .el-tree-node__content {
  font-weight: 400;
  color: var(--new-el-select-dropdown-item);
}

.search {
  .el-form-item:last-child {
    div {
      margin-left: 10px;
    }
  }
}
.common-blue-contain
  .el-pagination
    margin-top 18px
  .startWorkDuration
    width 100px!important;/*no*/
  .endWorkDuration
    width 100px!important;/*no*/
.el-tree
  background-color: var(--new-input-bg);
>>>.el-tree-node__content
  color: var(--new-el-select-dropdown-item);
</style>

<style scoped>
.el-select-dropdown {
  width: 200px !important; /* no */
}
</style>
